import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import { motion } from "framer-motion";

// Import Assets
import archive1 from "../../Assets/ArchiveSection/Archive1.png";
import archive2 from "../../Assets/ArchiveSection/Archive2.svg";
import archive3 from "../../Assets/ArchiveSection/Archive3.svg";
import archive4 from "../../Assets/ArchiveSection/Archive4.svg";

const ArchiveSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#F6F3F2",
        width: "100%",
        minHeight: "1300px",
        pt: "128px",
        pb: { xs: 8, md: 12 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Container maxWidth={false} sx={{ maxWidth: "1280px" }}>
        {/* Header Content */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "flex-end" },
            width: "100%",
            maxWidth: "1216px",
            height: { md: "80px" },
            mb: { xs: 6, md: "32px" },
            mx: "auto",
            gap: 4,
          }}
        >
          <Box
            sx={{
              width: "max-content",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              alignItems: "flex-start",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "12px",
                lineHeight: "16px",
                letterSpacing: "2px",
                textTransform: "uppercase",
                color: "#FF5722",
                textAlign: "left",
              }}
            >
              THE PORTFOLIO
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Manrope",
                fontWeight: 800,
                fontSize: { xs: "32px", md: "56px" },
                lineHeight: { xs: "1.1", md: "64px" },
                color: "#1C1917",
                textAlign: "left",
                whiteSpace: "nowrap",
              }}
            >
              Curated Archive
            </Typography>
          </Box>

          <Box
            sx={{
              width: { md: "357.7px" },
              height: { md: "48px" },
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter",
                fontSize: "14px",
                lineHeight: "24px",
                color: "#FF5722",
                textAlign: "right",
                fontWeight: 400,
              }}
            >
              Selected works that showcase our commitment to architectural
              purity and artisanal detail.
            </Typography>
          </Box>
        </Box>

        {/* Portfolio Gallery */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1216px",
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            gap: "32px", // Vertical gap between rows
          }}
        >
          {/* Top Row */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: "32px",
              width: "100%",
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              style={{ flex: 800 }}
            >
              <Box
                component="img"
                src={archive1}
                sx={{
                  width: "100%",
                  height: { xs: "300px", md: "384.01px" },
                  borderRadius: "10px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1 }}
              style={{ flex: 384 }}
            >
              <Box
                component="img"
                src={archive2}
                sx={{
                  width: "100%",
                  height: { xs: "300px", md: "384px" },
                  borderRadius: "10px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </motion.div>
          </Box>

          {/* Bottom Row */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: "36px",
              width: "100%",
            }}
          >
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              style={{ flex: 488 }}
            >
              <Box
                component="img"
                src={archive3}
                sx={{
                  width: "100%",
                  height: { xs: "400px", md: "696px" },
                  borderRadius: "10px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.3 }}
              style={{ flex: 692 }}
            >
              <Box
                component="img"
                src={archive4}
                sx={{
                  width: "100%",
                  height: { xs: "400px", md: "696px" },
                  borderRadius: "10px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </motion.div>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ArchiveSection;
